export const WindowsAgentVersionSupportsOfflineLicenseManagement = 796;
export const UnixAgentVersionSupportsOfflineLicenseManagement = 424;
